/**
 * CF-049 Product Tiles — desktop column density (`numberItemsPerView`) ties hero frame width at lg+ only.
 * Below lg: grid tiles fluid (`maxW: 100%`); Product Tiles **carousel** uses a fixed slide width
 * (`PRODUCT_TILE_CAROUSEL_MOBILE_SLIDE_WIDTH_PX` — same for 3-up and 4-up presets).
 *
 * Portrait ratio matches legacy PLP tiles (317×400).
 */

/** Width ÷ height for tile hero frames (same as legacy `317 / 400`). */
export const PRODUCT_TILE_FRAME_RATIO = 317 / 400;

/** Desktop (lg+) hero max-width in px — wider tiles when fewer columns across 1440 layout. */
export const PRODUCT_TILE_DESKTOP_IMAGE_WIDTH_PX = Object.freeze({
  /** Three tiles across desktop */
  3: 424,
  /** Four tiles across desktop */
  4: 317,
});

/**
 * Product Tiles outer Swiper (`product-tiles-carousel` / `product-tiles-carousel-3`): slide width in px
 * below the lg breakpoint — identical for 3-item and 4-item desktop configs.
 */
export const PRODUCT_TILE_CAROUSEL_MOBILE_SLIDE_WIDTH_PX = 276;

/**
 * Maps Contentful `numberItemsPerView` to desktop column count (3 vs 4).
 * `'3'`, `'3.2'` → 3-up; `'4.2'`, unset, anything else → 4-up.
 *
 * @param {string|undefined|null} numberItemsPerView
 * @returns {3|4}
 */
export function resolveProductTilesDesktopColumnCount(numberItemsPerView) {
  const raw =
    numberItemsPerView === undefined || numberItemsPerView === null ?
      '' :
      String(numberItemsPerView).trim();

  if (raw === '3' || raw === '3.2') {
    return 3;
  }

  return 4;
}

/**
 * Hero `maxW` at lg breakpoint for Instock / Range tiles inside Product Tiles.
 *
 * @param {3|4} columnCount
 * @returns {number}
 */
export function getProductTilesDesktopHeroMaxWidthPx(columnCount) {
  return columnCount === 3 ?
    PRODUCT_TILE_DESKTOP_IMAGE_WIDTH_PX[3] :
    PRODUCT_TILE_DESKTOP_IMAGE_WIDTH_PX[4];
}
